import {
  FETCHING_LOGS,
  FETCHING_LOGS_SUCCEEDED,
  FETCHING_LOGS_FAILED,
  FETCHING_METRICS,
  FETCHING_METRICS_SUCCEEDED,
  FETCHING_METRICS_FAILED,
  FETCHING_USER_METRICS,
  FETCHING_USER_METRICS_SUCCEEDED,
  FETCHING_USER_METRICS_FAILED
} from "constants/actionTypes";

const initState = {
  logs: {
    items: [],
    loading: false,
    pagination: {
      currentPage: -1,
      totalPages: 1,
      recordsPerPage: 20,
      totalRecordsCount: 0,
    },
    error: null
  },
  metrics: {
    actions: 0,
    errors: 0,
    loading: false,
    error: null
  },
  userMetrics: {
    items: [],
    loading: false,
    error: null
  },
};

function auditLogsReducer(state = initState, action) {
  switch (action.type) {
    case FETCHING_LOGS: {
      var records = action.payload;
      return {
        ...state,
        logs: {
          ...state.logs,
          items: [],
          loading: true
        },
      };
    }

    case FETCHING_LOGS_SUCCEEDED: {
      var {currentPage, totalPages, recordsPerPage, records, totalRecordsCount} = action.payload;
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          items: records,
          pagination: {
            ...state.logs.pagination,
            currentPage:currentPage,
            totalPages:totalPages,
            recordsPerPage:recordsPerPage,
            totalRecordsCount: totalRecordsCount
          }
         
        },
      };
    }

    case FETCHING_LOGS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

     return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          items: [],
          error: error
        },
      };
    }

    case FETCHING_METRICS: {
      var records = action.payload;
      return {
        ...state,
        metrics: {
          ...state.metrics.items,
          loading: true
        },
      };
    }

    case FETCHING_METRICS_SUCCEEDED: {
      var {actions, errors} = action.payload;
      return {
        ...state,
        metrics: {
          ...state.metrics,
          loading: false,
          actions: actions,
          error: errors
        },
      };
    }

    case FETCHING_METRICS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

     return {
        ...state,
        metrics: {
          ...state.metrics,
          loading: false,
        error: error

        },
      };
    }

    case FETCHING_USER_METRICS: {
      var records = action.payload;
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          loading: true
        },
      };
    }

    case FETCHING_USER_METRICS_SUCCEEDED: {
      return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          loading: false,
          items: action.payload
        },
      };
    }

    case FETCHING_USER_METRICS_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

     return {
        ...state,
        userMetrics: {
          ...state.userMetrics,
          loading: false,
          error: error

        },
      };
    }

    default:
      return state;
  }
}

export { auditLogsReducer };
